import { decamelizeKeys } from 'humps';

import resolve from '../../../../api-client';
import { ANSWERS__GET, ANSWERS__POST } from '../constants';
import { getAnswersUrl } from '../../util';

export const anwsersSubmit = (token, answers, pageId) => (dispatch, getState) => {
  const stateToken = getState().surveyClient.get('token');

  return dispatch(
    resolve({
      method: 'post',
      data: decamelizeKeys({
        answers,
        pageId,
        token: stateToken || token,
      }),
      type: ANSWERS__POST,
      url: getAnswersUrl(),
      retry: 3,
    }),
  );
};

export const anwsersFetch = () => (dispatch, getState) => {
  const token = getState().surveyClient.get('token');

  const action = resolve({
    method: 'get',
    params: decamelizeKeys({
      token,
    }),
    type: ANSWERS__GET,
    url: getAnswersUrl(),
    retry: 3,
  });

  return dispatch(action);
};
